<template>
  <div class="min-h-screen w-full p-4">
    <div class="bg-white p-4" v-loading="loading"
         element-loading-text="Loading..."
         element-loading-spinner="el-icon-loading"
         element-loading-background="rgba(0, 0, 0, 0.8)">
      <div class="filters flex flex-row flex-no-wrap justify-end">
        <el-dropdown split-button type="default" class="mr-4" @command="customerSegmentCommand">
          Customer Segment: {{segment}}
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="champion">Champion</el-dropdown-item>
            <el-dropdown-item command="recent customer">Recent Customer</el-dropdown-item>
            <el-dropdown-item command="loyal customer">Loyal Customer</el-dropdown-item>
            <el-dropdown-item command="potential loyalist">Potential Loyalist</el-dropdown-item>
            <el-dropdown-item command="promising">Promising</el-dropdown-item>
            <el-dropdown-item command="customer needing attention">Customer Needing Attention</el-dropdown-item>
            <el-dropdown-item command="about to sleep">About to Sleep</el-dropdown-item>
            <el-dropdown-item command="cannot lose them">Cannot lose them</el-dropdown-item>
            <el-dropdown-item command="at risk">At Risk</el-dropdown-item>
            <el-dropdown-item command="hibernating">Hibernating</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-dropdown split-button type="default" class="mr-4" @command="recencyCommand">
          Recency: {{recency}}
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="1">1</el-dropdown-item>
            <el-dropdown-item command="2">2</el-dropdown-item>
            <el-dropdown-item command="2">3</el-dropdown-item>
            <el-dropdown-item command="4">4</el-dropdown-item>
            <el-dropdown-item command="5">5</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-dropdown split-button type="default" class="mr-4" @command="frequencyCommand">
          Frequency: {{frequency}}
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="1">1</el-dropdown-item>
            <el-dropdown-item command="2">2</el-dropdown-item>
            <el-dropdown-item command="2">3</el-dropdown-item>
            <el-dropdown-item command="4">4</el-dropdown-item>
            <el-dropdown-item command="5">5</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-dropdown split-button type="default" class="mr-4" @command="monetaryCommand">
          Monetary: {{monetary}}
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="1">1</el-dropdown-item>
            <el-dropdown-item command="2">2</el-dropdown-item>
            <el-dropdown-item command="2">3</el-dropdown-item>
            <el-dropdown-item command="4">4</el-dropdown-item>
            <el-dropdown-item command="5">5</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <a @click="resetFilters()" href="#" class="text-blue-500 italic cursor-pointer mt-2" >Clear</a>
      </div>
      <div class="inline-block w-full mt-4">
        <el-pagination
          class="mt-8 mb-8 float-right"
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pagination.current_page"
          :page-size="pagination.limit"
          :page-count="pagination.pages"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagination.total_items">
        </el-pagination>
        <el-table
          :data="customers"
          :empty-text="'No Category available'"
          :default-sort = "{prop: 'id', order: 'ascending'}"
          style="width: 100%">
          <el-table-column
            type="selection">
          </el-table-column>
          <el-table-column
            prop="name"
            label="Name"
            width="300">
            <template slot-scope="scope">
              <span><router-link :tag="'a'" :to="`customer/customers/${scope.row.id}`">{{scope.row.first_name}} {{scope.row.last_name}}</router-link></span>
            </template>
          </el-table-column>
          <el-table-column
            prop="monetary"
            label="LifeTime Sales Value">
            <template slot-scope="scope">
              <span>N {{numberFormat(scope.row.monetary, '0,0')}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="frequency_score"
            label="Frequency">
          </el-table-column>
          <el-table-column
            prop="recency_score"
            label="Recency">
          </el-table-column>
          <el-table-column
            prop="monetary_score"
            label="Monetary">
          </el-table-column>
        </el-table>
        <el-pagination
          class="mt-8 mb-8 float-right"
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pagination.current_page"
          :page-size="pagination.limit"
          :page-count="pagination.pages"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagination.total_items">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Customers',
  data() {
    return {
      loading: false,
      page: 1,
      limit: 10,
      recency: 'All',
      frequency: 'All',
      monetary: 'All',
      segment: 'All',
    };
  },
  computed: {
    customers() {
      return this.$store.state.AICustomers.customers;
    },
    pagination() {
      return this.$store.state.AICustomers.customers_pagination;
    },
  },
  methods: {
    async handleSizeChange(args) {
      this.limit = args;
      await this.fetchCustomers();
    },
    async handleCurrentChange(args) {
      this.page = args;
      await this.fetchCustomers();
    },
    async fetchCustomers() {
      try {
        this.loading = true;
        await this.$store.dispatch('AICustomers/getCustomers', { page: this.page, limit: this.limit });
        this.loading = false;
      } catch (e) {
        this.loading = false;
      }

      this.loading = false;
    },
    async recencyCommand(command) {
      this.recency = command;
      this.$store.commit('AICustomers/setFilters', { filter: 'rec', payload: command });
      await this.fetchCustomers();
    },

    async frequencyCommand(command) {
      this.frequency = command;
      this.$store.commit('AICustomers/setFilters', { filter: 'freq', payload: command });
      await this.fetchCustomers();
    },

    async monetaryCommand(command) {
      this.monetary = command;
      this.$store.commit('AICustomers/setFilters', { filter: 'mon', payload: command });
      await this.fetchCustomers();
    },

    async customerSegmentCommand(command) {
      this.segment = command;
      this.$store.commit('AICustomers/setFilters', { filter: 'seg', payload: command });
      await this.fetchCustomers();
    },

    async resetFilters() {
      this.recency = 'All';
      this.monetary = 'All';
      this.segment = 'All';
      this.frequency = 'All';
      await this.$store.commit('AICustomers/setProperty', { property: 'customers_filter', payload: {} });
      await this.fetchCustomers();
    },
  },
};
</script>

<style scoped>

</style>
